import menu from "./lib/menu";
import animadoAlAparecer from "./lib/animado-al-aparecer";
import formulario from "./lib/formulario";
import proyectos from "./martos/proyectos";
import galeria from "./martos/galeria";
import leerMas from "./martos/leerMas";
require('../sass/app.scss');
var ajustaVw = function () {
    document.documentElement.style.setProperty('--vw', "".concat(document.documentElement.clientWidth, "px"));
};
var dataLayer = window.dataLayer;
proyectos();
galeria();
leerMas();
addEventListener('resize', ajustaVw);
addEventListener('load', ajustaVw);
ajustaVw();
menu();
animadoAlAparecer('.animado');
formulario('form', {
    dataLayer: dataLayer,
    ocultarEtiquetas: true
});
